import type { FunctionComponent } from 'react';

import { token } from '@trello/theme';

import { SkeletonComponent } from './SkeletonComponent';
import { TrelloLogo } from './TrelloLogo';

interface LoggedInHeaderSkeletonProps {
  backgroundColor?: string;
}

export const LoggedInHeaderSkeleton: FunctionComponent<
  LoggedInHeaderSkeletonProps
> = ({ backgroundColor: bgColor }) => {
  const defaultBackgroundColor = token('elevation.surface', '#FFFFFF');
  const backgroundColor = bgColor ?? defaultBackgroundColor;

  return (
    <div
      id="header"
      data-testid="logged-in-skeleton-header"
      style={{
        minHeight: 44,
        maxHeight: 44,
        backgroundColor,
      }}
    >
      <div
        style={{
          backgroundColor,
          height: 32,
          padding: `${token('space.075', '6px')} ${token('space.050', '4px')}`,
          display: 'flex',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
            gap: token('space.150', '12px'),
          }}
        >
          <SkeletonComponent width={32} />
          <TrelloLogo />
          <div
            style={{
              alignItems: 'stretch',
              display: 'flex',
              flexGrow: 1,
              flexShrink: 0,
              flexBasis: 0,
              height: '100%',
              position: 'relative',
            }}
          >
            <div
              style={{
                display: 'flex',
                margin: `${token('space.0', '0px')} ${token('space.050', '4px')}`,
                gap: token('space.050', '4px'),
              }}
            >
              <SkeletonComponent width={124} />
              <SkeletonComponent width={90} />
              <SkeletonComponent width={90} />
              <SkeletonComponent width={110} />
              <div style={{ width: token('space.050', '4px') }} />
              <SkeletonComponent width={68} />
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
            gap: token('space.050', '4px'),
          }}
        >
          <SkeletonComponent width={250} />
          <SkeletonComponent width={32} />
          <SkeletonComponent width={32} />
          <SkeletonComponent width={32} circle />
        </div>
      </div>
    </div>
  );
};
